let swiper = new Swiper('.mobile-swiper', {
  loop: true,
  //autoHeight: true,
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

//Toggle View
let viewBtn = document.querySelectorAll('.view-btn');

if(viewBtn.length != 0) {
  viewBtn.forEach((item, i) => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      numberView(i);
    });
  });
}

let numberView = function(v){
  let collectionCon = document.querySelector('.loop');

  if(v == 0){
    viewBtn[1].classList.remove('active');
    viewBtn[2].classList.remove('active');
    viewBtn[0].classList.add('active');

    collectionCon.classList.remove('sm-view');
    collectionCon.classList.add('lg-view');
  } else if(v == 1){
    viewBtn[0].classList.remove('active');
    viewBtn[2].classList.remove('active');
    viewBtn[1].classList.add('active');

    collectionCon.classList.remove('sm-view');
    collectionCon.classList.remove('lg-view');
  } else if(v == 2) {
    viewBtn[0].classList.remove('active');
    viewBtn[1].classList.remove('active');
    viewBtn[2].classList.add('active');

    collectionCon.classList.remove('lg-view');
    collectionCon.classList.add('sm-view');
  } else {
    console.log("Something with the view is wrong!");
  }
}

let resetView = function(){
  let collectionCon = document.querySelector('.loop');

  collectionCon.classList.remove('sm-view');
  collectionCon.classList.remove('lg-view');

  viewBtn[0].classList.remove('active');
  viewBtn[2].classList.remove('active');

  checkAllWraps();
}

let toggleViewBtn = document.querySelector('.toggle-view-btn');

if(toggleViewBtn != null){
  toggleViewBtn.addEventListener('click', function(e){
    e.preventDefault();
    resetView();
    toggleView();
  });
}

let toggleView = function(){
  let collectionCon = document.querySelector('.loop');

  collectionCon.classList.remove('sm-view');
  collectionCon.classList.remove('lg-view');

  collectionCon.classList.toggle('full-view');

  checkAllWraps();
}

window.addEventListener('load', function() {
  let heroLogo = document.querySelector('.hero .logo');
  if(heroLogo != null){
    setTimeout(() => {
      document.querySelector('.hero .logo').classList.add('show');
    }, 500);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const nextBtn = document.querySelector('.next-btn');
  const loop = document.querySelector('.loop');
  let nextUrl = nextBtn?.getAttribute('href');
  let loading = false;

  if (nextUrl && loop) {
    const trigger = document.createElement('div');
    trigger.id = 'scroll-trigger';
    trigger.style.height = '1px';
    loop.parentNode.insertBefore(trigger, loop.nextSibling);

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: '#scroll-trigger',
      triggerHook: 1
    })
      .addTo(controller)
      .on('enter', function () {
        if (!loading && nextUrl) {
          loading = true;
          fetchNextPage(nextUrl);
        }
      });
  }

  function fetchNextPage(url) {
    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newProducts = doc.querySelectorAll('.product');
        const newNextBtn = doc.querySelector('.next-btn');

        newProducts.forEach(product => {
          loop.appendChild(product);
        });

        nextUrl = newNextBtn ? newNextBtn.getAttribute('href') : null;
        if (!nextUrl) {
          document.querySelector('.next-btn')?.remove();
        }

        initializeSwiper();
        initializeScrollTrigger();

        loading = false;
      })
      .catch(err => {
        console.error('Failed to fetch next page:', err);
        loading = false;
      });
  }

  function initializeSwiper() {
    new Swiper('.mobile-swiper', {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  }

  function initializeScrollTrigger() {
    const bottomLogo = document.querySelector('.bottom-logo');
    if (!bottomLogo) return;

    gsap.registerPlugin(ScrollTrigger);

    function debounce(func, wait, immediate) {
      let timeout;
      return function () {
        const context = this, args = arguments;
        const later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    window.addEventListener('load', debounce(function () {
      gsap.to('.bottom-logo', {
        scrollTrigger: {
          trigger: '.logo-trigger',
          start: 'top bottom',
          end: 'bottom top',
          toggleClass: { targets: bottomLogo, className: 'sticky' },
        }
      });
    }, 250));
  }
});


//Color Wrap
let flexContainers = document.querySelectorAll('.options');

let checkWrap = function(container) {
  const children = Array.from(container.children);
  const firstItemTop = children[0].offsetTop;

  const isWrapped = children.some(child => child.offsetTop > firstItemTop);

  if (isWrapped) {
    container.classList.add('wrap');
  } else {
    container.classList.remove('wrap');
  }
}

let checkAllWraps = function() {
  flexContainers.forEach(container => checkWrap(container));
}

document.addEventListener('DOMContentLoaded', function () {
  checkAllWraps();

  window.addEventListener('resize', checkAllWraps);
});

//Filters Button
let filtersBtn = document.querySelector('.filters-btn');
filtersBtn.addEventListener('click', function(event) {
  event.preventDefault();
  document.querySelector('.mid-bar').classList.toggle('active');
});